export default function runIfDefined<T>(
  expression: T | undefined | null,
  fun: (e: T) => void
) {
  if (expression) return fun(expression);
}
